import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-esi-form',
  templateUrl: './esi-form.component.html',
  styleUrls: ['./esi-form.component.css']
})
export class EsiFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/esi/esi-form/esi-form.component.ts